import React, { useContext, useEffect } from "react";
import { AppContext, FilterType, FILTER_CONFIG } from "./AppContext";
import { Filter, FilterCheckbox } from "./Filter";

const DEFAULT_FILTER = {
  venueType: [],
  capacityCategory: [],
  accessibilityAudience: false,
  accessibilityArtist: false,
};

export const Filters: React.FC = () => {
  const {
    filters,
    setFilters,
    filterCounter,
    setFilterCounter,
    selectedFilters,
    setSelectedFilters,
    setShowFilters,
  } = useContext(AppContext);

  const applyFilters = () => {
    setFilters(selectedFilters);
    setShowFilters(false);
  };

  const clearFilters = () => {
    setFilters(DEFAULT_FILTER);
    setSelectedFilters(DEFAULT_FILTER);
    setFilterCounter(filterCounter + 1); // hack to force rerender when filters are reset
  };

  return (
    <div key={filterCounter}>
      {/* <div className="my-2 flex-grow flex flex-col">
            <h3 className="heading-4 mb-1">Filter venues</h3>
        </div> */}

      {Object.entries(FILTER_CONFIG).map(([key, filter]) => {
        if (filter.type === "multiselect") {
          return (
            <Filter
              key={key}
              label={filter.label}
              initialSelectedItems={filters[key as keyof FilterType]}
              items={filter.selectValues}
              onChange={(selected: any[]) => {
                setSelectedFilters({
                  ...selectedFilters,
                  [key]: selected,
                });
              }}
            />
          );
        }

        if (filter.type === "checkbox") {
          return (
            <FilterCheckbox
              key={key}
              label={filter.label}
              description={filter.description}
              checked={filters[key as keyof FilterType]}
              onChange={(checked: boolean) => {
                setSelectedFilters({
                  ...selectedFilters,
                  [key]: checked,
                });
              }}
            />
          );
        }

        return null;
      })}

      <div className="flex flex-row mt-6">
        <button
          className="block bg-black text-offwhite button-text button mr-2"
          onClick={() => applyFilters()}
        >
          Update
        </button>

        <button
          className="block text-black button-text py-2 ml-4 underline"
          onClick={() => clearFilters()}
        >
          Clear filters
        </button>
      </div>
    </div>
  );
};
